import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

class Slug extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.formData.title,
            slug: this.props.formData.slug
        };
        this.onChange = this.onChange.bind(this);
        this.titleInput = React.createRef();
        this.slugInput = React.createRef();
    }

    onChange(event) {
        if (event.target.id === this.props.idSchema.title.$id) {
            let replaced = event.target.value;
            replaced = replaced.replace(/[^a-zA-Z]+/g, '-');
            this.setState({ title: event.target.value, slug: replaced.toLowerCase() }, () => this.props.onChange(this.state))
        }
    }

    render() {
        let titleTitle = (this.props.schema.properties.title.title) ? <label class="control-label" for={this.props.idSchema.title.$id}>{this.props.schema.properties.title.title}</label> :"";
        let titleDesc = (this.props.schema.properties.title.description) ? <p id={this.props.idSchema.title.$id + '__description'} class="field-description">{this.props.schema.properties.title.description}</p> : "";

        let slugTitle = (this.props.schema.properties.slug.title) ? <label class="control-label" for={this.props.idSchema.slug.$id}>{this.props.schema.properties.slug.title}</label> : "";
        let slugDesc = (this.props.schema.properties.slug.description) ? <p id={this.props.idSchema.slug.$id + '__description'} class="field-description">{this.props.schema.properties.slug.description}</p> : "";

        return (
            <>
                <fieldset id={this.props.idSchema.$id}>
                    <div class="form-group field field-string">
                        {titleTitle}
                        {titleDesc}
                        <input class="form-control" id={this.props.idSchema.title.$id} label={this.props.schema.properties.title.title} placeholder="" type="text" value={this.state.title} onChange={this.onChange} />
                    </div>
                    <div class="form-group field field-string">
                        {slugTitle}
                        {slugDesc}
                        <input class="form-control" id={this.props.idSchema.slug.$id} label={this.props.schema.properties.slug.title} placeholder="" type="text" value={this.state.slug} />
                    </div>
                </fieldset>
            </>
        );
    }
}

const SlugWidget = withRouter(Slug);

function NewSlug(props) {
    return (
        <SlugWidget {...props} />
    );
}

export default NewSlug